export function compressAmount(amount) {
  if (amount >= 10000000) {
    return "₹" + (amount / 10000000).toFixed(1) + " Cr";
  } else if (amount >= 100000) {
    return "₹" + (amount / 100000).toFixed(1) + " L";
  } else {
    return "₹" + amount?.toString();
  }
}


export function getModeName (type) {
  if (Number(type) == 1) return "CASH";
  else if (Number(type) == 2) return "UPI";
  else if (Number(type) == 3) return "NET_BANKING";
  else if (Number(type) == 4) return "CARD";
  else return "UPI";
}

export function capitalizeFirstLetter (str) {
  return str
    .split(" ") // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" "); // Join the words back into a string
};

export const truncateText = (text, maxLength) =>
  text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

export const furnishedOptions = [
  { value: 1, label: "Fully Furnished" },
  { value: 2, label: "Semi Furnished" },
  { value: 3, label: "Unfurnished" },
];

export const getFurnishedLabel = (value) => {
  return furnishedOptions.find(item => item.value === value)?.label || "-";
};

export const foodPreferred = [
  { label: "Veg", value: 1 },
  { label: "Non-Veg", value: 2 },
  { label: "Whatever", value: 3 },
]

export const getFoodPreferenceLabel = (value) => {
  return foodPreferred.find(item => item.value === value)?.label || "-";
};